import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { FurnitureApplicantEmployerComponent } from './furniture-applicant-employer.component';
import { FurnitureApplicantEmployerRoutingModule } from './furniture-applicant-employer-routing.module';
import { EmployerInfoModule } from 'src/app/components/controls/employer-info/employer-info.module';
import { EmployerPaymentInfoModule } from 'src/app/components/controls/employer-payment-info/employer-payment-info.module';
import { OtherIncomesInfoModule } from 'src/app/components/controls/other-incomes-info/other-incomes-info.module';
import { ContactInfoModule } from 'src/app/components/controls/contact-info/contact-info.module';
import { SecureInfoModule } from 'src/app/components/controls/secure-info/secure-info.module';
import { ValidationTextModule } from 'src/app/components/validation-text/validation-text.module';
import { ElectronicSignatureInfoModule } from 'src/app/components/controls/electronic-signature-info/electronic-signature-info.module';

@NgModule({
  declarations: [FurnitureApplicantEmployerComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FurnitureApplicantEmployerRoutingModule,
    EmployerInfoModule,
    EmployerPaymentInfoModule,
    OtherIncomesInfoModule,
    SecureInfoModule,
    ContactInfoModule,
    ValidationTextModule,
    ElectronicSignatureInfoModule,
  ],
})
export class FurnitureApplicantEmployerModule {}
